import React from 'react';
import { IoRestaurantOutline } from 'react-icons/io5';

const ChatListContainer = ({
    meetingTitle,
    meetingImageUrl,
    lastChatContent,
    lastChatCreatedAt,
    hasUnreadChat,
    onClick
}) => {
    const formatTime = (timeString) => {
        if (!timeString) return '';

        // LocalDateTime 형식을 Date 객체로 변환
        const date = new Date(timeString);
        const now = new Date();
        const diffInMinutes = Math.floor((now - date) / (1000 * 60));

        if (diffInMinutes < 1) return '방금';
        if (diffInMinutes < 60) return `${diffInMinutes}분 전`;
        if (diffInMinutes < 1440) return `${Math.floor(diffInMinutes / 60)}시간 전`;
        return date.toLocaleDateString('ko-KR', { month: 'numeric', day: 'numeric' });
    };


    return (
        <div
            onClick={onClick}
            className="bg-white rounded-lg border border-gray-200 p-4 cursor-pointer active:bg-gray-50"
        >
            <div className="flex items-center">
                {/* 모임 이미지 */}
                <div className="mr-4">
                    {meetingImageUrl ? (
                        <img
                            src={meetingImageUrl}
                            alt={meetingTitle}
                            className="w-16 h-16 rounded-lg object-cover"
                        />
                    ) : (
                        <div className="w-16 h-16 rounded-lg bg-gray-200 flex items-center justify-center">
                            <IoRestaurantOutline size={24} className="text-gray-400" />
                        </div>
                    )}
                </div>

                {/* 채팅 정보 */}
                <div className="flex-1 min-w-0">
                    <div className="flex items-start justify-between mb-1">
                        <h3 className="text-sm font-semibold text-gray-900 truncate">
                            {meetingTitle}
                        </h3>
                        <div className="flex items-center ml-2">
                            <span className="text-xs text-gray-500">
                                {formatTime(lastChatCreatedAt)}
                            </span>
                            {hasUnreadChat && (
                                <div className="ml-2 bg-orange-500 text-white text-xs rounded-full min-w-[20px] h-5 flex items-center justify-center px-1">
                                    NEW
                                </div>
                            )}
                        </div>
                    </div>
                    <p className="text-sm text-gray-600 truncate">
                        {lastChatContent || '아직 대화가 없습니다'}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default ChatListContainer;
